module.exports = __webpack_public_path__ + "img/139.fb1695a4.jpg";